import { withTransaction } from '@elastic/apm-rum-react';

export const withRouteTransaction = (name: string) => (Component: React.ComponentType) =>
  withTransaction(name, 'route-change')(Component);
